import gql from "graphql-tag";

export const SUBSCRIBE_PURCHASE_REQUEST_BY_PRODUCT_ID_AND_ORDERED_DATE = gql`
subscription getPurchaseRequestByProductIdAndOrderedDate($productId: uuid!, $orderedDate: date!){  
  purchaseRequests: PurchaseRequest(where: { productId: {_eq: $productId}, orderedDate: {_eq: $orderedDate}}, order_by: {created_at: desc}) {
    id
    Vendor {id name vendorCode profileImage}
    statusId
    orderedDate
    deliveryDate   
    rate
    cartoons
    productType
    transportation
    qtyPerCartoon
    created_at
  }
}`

export function generate_FETCH_PURCHASE_REQUESTS(name, type = 'query') {
    return gql`
  ${type} ${name}($startDate:timestamptz!, $endDate:timestamptz!, $statusId:[uuid!], $search:String, $offset: Int!, $limit: Int!, $orderBy: [PurchaseRequest_order_by!]){
   ${name}: PurchaseRequest(where:{_and:[ { created_at: {_gte: $startDate}},{ created_at: {_lte: $endDate}}, { statusId: {_in: $statusId}}, 
        {_or: [{Product: {name: {_ilike: $search}}}, {Vendor: {vendorCode: {_ilike: $search}}}, {biltyNumber: {_ilike: $search}} ]} 
        ]}, offset: $offset, limit: $limit, order_by: $orderBy ){
    id
    statusId
    Status {id status}
    orderedDate
    deliveryDate
    receivedDate 
    rejectedDate   
    rate
    cartoons
    qtyPerCartoon
    totalQty
    receivedStock 
    biltyNumber
    Vendor {id vendorCode}
    Product {
       id
       name
       sku
       Attachments(order_by: {type: asc, isDefault: desc}) {id path type}       
    }            
 }
}`
}

export function generate_SUBSCRIBE_PURCHASE_REQUESTS_COUNT(name) {
    return gql`
  subscription ${name}($startDate:timestamptz!, $endDate:timestamptz!, $statusId:[uuid!], $search:String){
   ${name}: PurchaseRequest_aggregate(where:{_and:[ { created_at: {_gte: $startDate}},{ created_at: {_lte: $endDate}}, { statusId: {_in: $statusId}}, 
        {_or: [{Product: {name: {_ilike: $search}}}, {Vendor: {vendorCode: {_ilike: $search}}}, {biltyNumber: {_ilike: $search}} ]} ]}){
    aggregate { count }                
   }
}`
}
